import { render } from "./CookieAccept.vue?vue&type=template&id=dbb1bec8"
import script from "./CookieAccept.vue?vue&type=script&lang=js"
export * from "./CookieAccept.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nikita/Documents/works/novofamil/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__